<template>
    <div class="point-selector d-flex justify-content-start  gap-3">
        <SearchableSelect v-if="!show_all_hosts && !popId" :items="listPops" :initial-selected-item="point.popId"
            placeholder="Selecione uma Pop" @item-selected="(value) => { onPopChange(value) }" />

        <SearchableSelect v-if="show_all_hosts || point.popId || popId" :items="show_all_hosts ? zabbixHosts : popHosts"
            :initial-selected-item="point.hostId" placeholder="Selecione um Host"
            @item-selected="(value) => { onHostChange(value) }" />

        <SearchableSelect v-if="point.hostId" :items="hostsItems" :initial-selected-item="point.itemId"
            placeholder="Selecione um item" @item-selected="(value) => { onItemChange(value) }" />

        <SearchableSelect v-if="point.itemId" :items="itemsTriggers" :initial-selected-item="point.triggerId"
            placeholder="Selecione uma trigger" @item-selected="(value) => { onTriggerChange(value) }" />
    </div>
</template>

<script>
import { CompanyService, PopService } from "@/services/backend/ApiService";
import SearchableSelect from "./SearchableSelect.vue";
import { ZabbixApiService } from "@/services/backend/zabbixApiService";
import { defineExpose } from 'vue';

export default {
    components: {
        SearchableSelect
    },
    props: {
        company_id: String,
        popId: Number,
        show_all_hosts: Boolean,
        pointInit: Object,
        disabled: Boolean
    },
    data() {
        return {
            point: {
                popId: null,
                hostId: null,
                hostName: null,
                itemId: null,
            },
            popHosts: [],
            zabbixHosts: [],
            hostsItems: [],
            itemsTriggers: [],
            listPops: [],
            isEditing: false
        };
    },
    async mounted() {
        this.isEditing = this.$route.query.mode === 'edit';
        this.loadInitialValues()
        defineExpose({ reload: this.reload });
    },
    methods: {
        async loadInitialValues() {
            if (this.pointInit) this.point = this.pointInit;

            if (this.show_all_hosts) {
                this.zabbixHosts = await this.loadHostsOptions()
            }

            this.listPops = (await CompanyService.findOne(this.company_id)).pops.map((value) => {
                return {
                    option: `ID: ${value.id} - ${value.name}`,
                    value: value.id
                }
            })

            if (this.popId || this.point.popId) {
                this.popHosts = await this.loadPopHostsOptions();
            }

            if (this.point.hostId) {
                this.hostsItems = await this.loadItemsOptions()
            }

            if (this.point.itemId) {
                this.itemsTriggers = await this.loadTriggersOptions()
            }
        },
        async reload() {
            await this.loadInitialValues();
        },
        async onPopChange(value) {
            this.point.popId = value;
            this.popHosts = await this.loadPopHostsOptions();
            this.point.hostId = null;
            this.point.itemId = null;
            this.point.triggerId = null;
            this.$emit("update:point", this.point);
        },
        async onHostChange(hostId) {
            this.point.hostId = hostId
            this.hostsItems = await this.loadItemsOptions()

            this.point.itemId = null;
            this.point.triggerId = null;
            this.$emit("update:point", this.point);
        },
        async onItemChange(itemId) {
            this.point.itemId = itemId;
            this.itemsTriggers = await this.loadTriggersOptions()

            this.point.triggerId = null;
            this.$emit("update:point", this.point);
        },
        async onTriggerChange(triggerId) {
            this.point.triggerId = triggerId;
            this.$emit("update:point", this.point);
        },
        async loadPopHostsOptions() {
            return (await PopService.findOne(this.popId || this.point.popId)).hosts.map((value) => {
                return {
                    option: `ID: ${value.hostId} - ${value.name}`,
                    value: value.hostId
                }
            })
        },
        async loadHostsOptions() {
                return (await ZabbixApiService.getHosts(this.company_id)).map((value) => {
                    return {
                        option: `ID: ${value.hostid} - ${value.host}`,
                        value: value.hostid
                    }
                });
            },
        async loadItemsOptions() {
                return (await ZabbixApiService.getHostItems(this.company_id, this.point.hostId)).map((value) => {
                    return {
                        option: `ID: ${value.itemid} - ${value.name}`,
                        value: value.itemid
                    }
                });
            },
        async loadTriggersOptions() {
                return (await ZabbixApiService.getItemTriggers(this.company_id, this.point.itemId)).map((value) => {
                    return {
                        option: `ID: ${value.triggerid} - ${value.description}`,
                        value: value.triggerid
                    }
                });
            },
        },
        watch: {
            pointInit: {
                deep: true,
                immediate: true,
                async handler(newVal) {
                    if (newVal && (newVal.popId && this.point.popId == null)) {
                        await this.loadInitialValues();
                    }
                }
            },
            point: {
                deep: true,
            },
        },
    };
</script>



<style scoped>
.point-selector {
    margin-bottom: 10px;
}

select {
    width: 300px;
}
</style>